import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
//import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import PageMeta from "../common/PageMeta";
import PageBreadcrumb from "../common/PageBreadCrumb";
import ComponentCard from "../common/ComponentCard";
import Alert from "../../components/ui/alert/Alert";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../ui/table";

import {
  TrashBinIcon,
  PencilIcon,
  CheckLineIcon,
  SubscriptionsIcon
} from "../../icons";

import { Link } from "react-router";
import Badge from "../ui/badge/Badge";
import { createUserSubscription, resetCreateUserSubscription, getAllSubscriptions, emptyRedux } from "../../actions/subscriptionAction";
import { checkAuth } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

export default function SelectPlan() {

  dayjs.extend(relativeTime);

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const [subData, setSubData] = useState([]);

  const createUserSubscriptionRes = useSelector(state => state.subscriptionReducer.createUserSubscription);

  const createUserSubscriptionFailed = useSelector(state => state.subscriptionReducer.createUserSubscriptionFailed);

  const getAllSubscriptionsRes = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlan);

  const getAllSubscriptionsFailed = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlanFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const [selectPlan, setSelectPlan] = useState("");

  const [selectedPlanId, setSelectedPlanId] = useState(0);

  const tiers = [
    {
      name: 'Hobby',
      id: 'tier-hobby',
      href: '#',
      priceMonthly: '$29',
      description: "The perfect plan if you're just getting started with our product.",
      features: ['25 products', 'Up to 10,000 subscribers', 'Advanced analytics', '24-hour support response time'],
      featured: false,
    },
    {
      name: 'Enterprise',
      id: 'tier-enterprise',
      href: '#',
      priceMonthly: '$99',
      description: 'Dedicated support and infrastructure for your company.',
      features: [
        'Unlimited products',
        'Unlimited subscribers',
        'Advanced analytics',
        'Dedicated support representative',
        'Marketing automations',
        'Custom integrations',
      ],
      featured: true,
    },
  ]
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
  useEffect(() => {

    dispatch(getAllSubscriptions());
  }, []);


  useEffect(() => {
      
    if(typeof getAllSubscriptionsRes != "undefined" && getAllSubscriptionsRes.statusCode == 200){
      let data = [];

      let planlist = getAllSubscriptionsRes.data.plans;
      const planData = planlist.map((item) => {
              return {
                "id": item.id,
                "name": item.name,
                "description": item.description,
                "tenure": item.tenure,
                "amount": item.amount,
                "scheduleType": item.scheduleType,
                "schedule": item.schedule,
                "createdAt": item.createdAt
              };
      });

      console.log("planData", planData);
      setSubData([
          ...planData
      ]);

    }

  }, [getAllSubscriptionsRes]);



  useEffect(() => {
    
    if(typeof createUserSubscriptionRes != "undefined" && createUserSubscriptionRes.statusCode == 200){

      setShowSuccessAlert(true);

      setTimeout(() => {
        setShowSuccessAlert(false);
      },6000);
    }

  }, [createUserSubscriptionRes]);


  const choosePlanDialog = (planId) => {

    
    let subName = "";

    for(let si in subData){
      if(subData[si].id === parseInt(planId)){

        subName = subData[si].name;

        break;
        
        /*setSelectPlan(subData[si].name);

        setSelectedPlanId(planId);

        setModalOpen(true);*/
      }
    }

    

    setSelectPlan(subName);

    setSelectedPlanId(planId);

    setModalOpen(true);
    
  };  

  const addDate = (currentDate, count, schedule) => {

    let newDate = new Date(currentDate);

    if(schedule === "yearly"){
      newDate.setFullYear(newDate.getFullYear() + count);
    }

    if(schedule === "monthly"){
      newDate.setMonth(newDate.getMonth() + count);
    }

    if(schedule === "weekly"){
      newDate.setDate(newDate.getDate() + count * 7);
    }

    return newDate;
  }

  const handleSubmit = () => {

    let subItem = {};

    subData.forEach(function(item, index) {

      if(selectedPlanId == item.id){

        subItem = item;

      }

    });

    let tmpEndData = addDate(new Date(), subItem.tenure, subItem.schedule);
    
    let data = {
      "userId" : localStorage.id,
      "subscriptionPlanId" : selectedPlanId,
      "startDate" : dayjs(new Date()).format('YYYY-MM-DD'),
      "endDate" : dayjs(tmpEndData).format('YYYY-MM-DD'),
    };

    dispatch(createUserSubscription(data));

    setSelectPlan("");

    setSelectedPlanId(0);
    
    setModalOpen(false);
  } 

  return (
    <>
      <PageMeta
        title="Subscription plans | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Subscription plan" />
      <div className="space-y-6">
        <ComponentCard title="All plans list">
          
                  <div className="relative isolate bg-white px-6 py-8 sm:py-4 lg:px-8">
                    <div aria-hidden="true" className="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl">
                      <div
                        style={{
                          clipPath:
                            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="mx-auto aspect-1155/678 w-[72.1875rem] bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
                      />
                    </div>
                    <div className="mx-auto max-w-4xl text-center">
                      <p className="mt-2 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-6xl">
                        Choose the right plan for you
                      </p>
                    </div>
                    <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-medium text-pretty text-gray-600 sm:text-xl/8">
                      Choose an affordable plan that’s suitable for you.
                    </p>
                    
                    {(
                      showSuccessAlert 

                      ? 
                      <div className="mx-auto max-w-4xl mt-8">
                      <Alert
                        variant="success"
                        title="Done!"
                        message="New subscription created successfully."
                        showLink={false}
                      />
                      </div>
                      : 
                      
                      null
                    )}
                    
                    <div className="mx-auto mt-16 grid grid-cols-1 items-center gap-x-6 gap-6 sm:mt-20 sm:gap-y-0 lg:grid-cols-2 sub-pack-parent">
                      {/* {tiers.map((tier, tierIdx) => ( */}

                      {subData.map((item) => (
                      
                        <div
                          key={item.id}
                          className={classNames(
                            'bg-white/60 sm:mx-8 lg:mx-0 sub-pack',
                            'lg:rounded-tr-3xl space-y-6 gap-y-6  gap-x-6 mb-7',
                            'rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10',
                          )}
                        >
                          <h3
                            id={item.id}
                            className={classNames(false ? 'text-indigo-400' : 'text-indigo-600', 'text-base/7 font-semibold')}
                          >
                            {item.name}
                          </h3>
                          <p className="mt-4 flex items-baseline gap-x-2">
                          {item.scheduleType == "fixed" ? 
                            <>
                            <span
                              className={classNames(
                                false ? 'text-white' : 'text-gray-900',
                                'text-5xl font-semibold tracking-tight',
                              )}
                            >
                              <small>₹</small>{parseInt(item.amount)}
                            </span>
                            <span className={classNames(false ? 'text-gray-400' : 'text-gray-500', 'text-base')}>/ month</span>
                            </>
                           : 
                           <>
                           <span
                              className={classNames(
                                false ? 'text-white' : 'text-gray-900',
                                'flexi-pack-amount font-semibold tracking-tight',
                              )}
                            >
                              <small>₹</small>500 - <small>₹</small> 50,000
                            </span>
                            <span className={classNames(false ? 'text-gray-400' : 'text-gray-500', 'text-base')}>/ @Any time</span>
                           </>
                           
                           }
                          </p>
                          <p className={classNames(false ? 'text-gray-300' : 'text-gray-600', 'mt-6 text-base/7')}>
                            {item.description}
                          </p>
                          <ul
                            role="list"
                            className={classNames(
                              false ? 'text-gray-300' : 'text-gray-600',
                              'mt-8 space-y-3 text-sm/6 sm:mt-10',
                            )}
                          >
                            <li className="flex gap-x-3">
                              <CheckLineIcon />
                                {(
                                  item.scheduleType === "fixed"
                                ?
                                  item.tenure + ' ' + (item.schedule == "monthly" ? "month(s)" : (item.schedule == "weekly" ? "week(s)" : "year(s)"))
                                :
                                  "No end date"
                                )}
                              </li>
                            {["Zero wastage", "5% discount"].map((feature) => (
                              <li key={feature} className="flex gap-x-3">
                                
                                <CheckLineIcon />{feature}
                              </li>
                            ))}
                          </ul>
                          {/*onClick={(e) => { setSelectPlan(item.name); setSelectedPlanId(item.id); setModalOpen(true); }}*/}
                          <a
                            href={"/subscription/request/"+item.id}
                            aria-describedby={item.id}
                            className={classNames(
                              true
                                ? 'bg-indigo-500 text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-indigo-500'
                                : 'text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 focus-visible:outline-indigo-600',
                              'mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10',
                            )}
                          >
                            Get started today
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>

        </ComponentCard>
      </div>



      <Dialog open={modalOpen} onClose={setModalOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95"
          >
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                  {/*<ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600" />*/}
                  <SubscriptionsIcon className="size-6" />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                    Subscribe the plan
                  </DialogTitle>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                    Please click the subscribe button to subscribe the <strong>{selectPlan}</strong> plan.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={() => handleSubmit()}
                className="bg-indigo-500 text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-indigo-500 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Subscribe
              </button>&nbsp;&nbsp;
              <button
                type="button"
                data-autofocus
                onClick={() => setModalOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
      </Dialog> 
    </>
  );
}